import styled, { css } from 'styled-components';
import colors from '@theme/colors';

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: 14px;
  line-height: 24px;
  padding-top: 24px;
`;

export const FloatingLabel = styled.label`
  position: absolute;
  top: 32px;
  line-height: 22px;
  user-select: none;
  z-index: 1;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  transform: scale(1) translate(0px, 0px);
  transform-origin: left top 0px;
  color: #808080;

  ${({ shouldShrink }) =>
    shouldShrink &&
    css`
      transform: scale(0.75) translate(0px, -28px);
    `}

  ${({ focused }) =>
    focused &&
    css`
      color: ${colors.PRIMARY};
    `}
`;

export const ContentWrapper = styled.div`
  padding-top: 12px;
`;

export const Underline = styled.hr`
  border-top: none rgb(224, 224, 224);
  border-left: none rgb(224, 224, 224);
  border-right: none rgb(224, 224, 224);
  border-bottom: 1px solid rgb(224, 224, 224);
  width: 100%;
  ${({ underlineHidden }) =>
    underlineHidden &&
    css`
      display: none;
    `}
`;

// TimeInput
export const TimeInput = styled.input.attrs({
  autoComplete: 'off',
})`
  background: transparent;
  color: ${colors.PRIMARY};
  padding: 0px;
  border: none;
  outline: none;
  cursor: inherit;
  opacity: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size: inherit;
  width: 1.3em;

  ${({ active }) =>
    active &&
    css`
      color: ${colors.BLACK};
    `}
`;

// ChipsInput
export const Chip = styled.div`
  display: inline-block;
  color: ${colors.WHITE};
  background-color: ${colors.PRIMARY};
  border-radius: 2px;
  border-color: ${colors.PRIMARY};
  padding: 0px 5px 0px 10px;
  font-size: 13px;
  cursor: default;
  margin-right: 5px;

  ${({ secondary }) =>
    secondary &&
    css`
      color: ${colors.DARK_GREY};
      background-color: ${colors.SECONDARY};
      border: 1px solid ${colors.DARK_GREY};
    `}
`;

export const ChipInputField = styled.input`
  background: transparent;
  font-size: 13px;
  color: ${colors.PRIMARY};
  padding: 0px;
  position: relative;
  border: none;
  outline: none;
  cursor: inherit;
  opacity: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: ${({ shouldShrink }) => (shouldShrink ? 0 : 'auto')};

  ${({ secondary }) =>
    secondary &&
    css`
      color: ${colors.DARK_GREY};
    `}
`;



// WEBPACK FOOTER //
// ./components/layout/CustomFormFields.js